import { render, staticRenderFns } from "./PromoHeader.vue?vue&type=template&id=ebf6180e&scoped=true&"
import script from "./PromoHeader.vue?vue&type=script&lang=js&"
export * from "./PromoHeader.vue?vue&type=script&lang=js&"
import style0 from "./PromoHeader.vue?vue&type=style&index=0&id=ebf6180e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebf6180e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
